import axios from "axios";
import { getCookie, setCookie } from "./cookie";

// Use environment variable for API URL, fallback to production
const BASE_URL = process.env.REACT_APP_API_URL || "https://data.qkira.com/api/";


// Figure generation runs a multi-minute pipeline. Without an explicit ceiling
// the browser default wins and the request dies before the server responds.
const REQUEST_TIMEOUT_MS = 5 * 60 * 1000;

export const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: REQUEST_TIMEOUT_MS,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = getCookie("accessToken");
    config.headers = {
      ...config.headers,
      Authorization: accessToken ? `Bearer ${accessToken}` : "",
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      setCookie("accessToken", "", 0);
    }
    return Promise.reject(error);
  }
);
